import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
//import jobmixin from '@/helpers/Mixins/JobMixin.js';
export default {
    methods: {
        async toggleProjectsEnabled() {
            var meta = {
                clientApiMethod: 'toggleProjectsEnabled',
                input: {},
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.setting.setting") })
            }
            var response = await client().post(store.state.apiRouteRoot + "Projects/ToggleFeature", null, { meta: meta })
            return response?.data;
        },
        async getAllProjects() {
            var meta = { clientApiMethod: 'getAllProjects', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Projects", { meta: meta })
            return response?.data;
        },
        async getProjectListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getProjectListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Projects/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getProject(ProjectId) {
            var meta = { clientApiMethod: 'getProject', input: { ProjectId: ProjectId } }
            var response = await client().get(store.state.apiRouteRoot + "Projects/" + ProjectId, { meta: meta })
            return response?.data;
        },
        async createProject(newProject) {
            var meta = {
                clientApiMethod: 'createProject',
                input: { newProject },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.machine.asset_type") })
            }
            var response = await client().put(store.state.apiRouteRoot + 'Projects', newProject, { meta: meta })
            return response?.data;
        },
        async changeProject(updatedProject) {
            var meta = {
                clientApiMethod: 'changeProject',
                input: { updatedProject },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.asset_type") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Projects', updatedProject, { meta: meta })
            return response?.data;
        },
        async deleteProject(ProjectId) {
            var meta = {
                clientApiMethod: 'deleteProject',
                input: { ProjectId: ProjectId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.machine.asset_type") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "Projects/" + ProjectId, { meta: meta })
            return response?.data;
        },
    }
}